import { render, staticRenderFns } from "./UniversityProfile.vue?vue&type=template&id=06fb0644&"
import script from "./UniversityProfile.vue?vue&type=script&lang=js&"
export * from "./UniversityProfile.vue?vue&type=script&lang=js&"
import style0 from "./UniversityProfile.vue?vue&type=style&index=0&id=06fb0644&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports